// This file was automatically generated from render.reportFeedItem.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.reportFeedItem');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.docTags');
goog.require('el8.template.button');
goog.require('el8.template.ptdata.addendums');
goog.require('el8.template.ptdata.letterReceipts');
goog.require('el8.template.ptdata.letters.attachments');
goog.require('el8.template.ptdata.model.attachment');
goog.require('el8.template.ptdata.model.message');
goog.require('el8.template.ptdata.model.noteItem');
goog.require('el8.template.ptdata.model.order');
goog.require('el8.template.ptdata.patients');
goog.require('el8.template.render.chartFeedItemNew');
goog.require('el8.template.render.reportFeedItem.referralDetail');
goog.require('el8.template.render.reportFeedItem.resultGrid');
goog.require('el8.template.render.signOff');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.baseItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8DialogFeedItem"><div class="overlayFeedItem el8FeedItemHover', (! opt_data.isSignedOff) ? ' containerNew' : '', (opt_data.isOrder) ? ' containerOrder' : '', '"><div class="overlayFeedHeaderContainer  am-highlight" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="statusText el8Elt"><span class="el8LeftArrowIcon"></span></span>', (el8Globals.FEATURES.BiDiLabs && opt_data.currentState == 'cancelled') ? '<span class="el8Strike el8999">' : '', (el8Globals.FEATURES.BiDiLabs) ? (opt_data.isOrder && opt_data.currentState == 'outstanding') ? '<span class="el8FeedItemNoticeText mr0">Outstanding</span>' : '' : '', '<span class="eltlr5">', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''), '</span><span class="item-description-text headerDescriptionText">', (! opt_data.isSignedOff) ? '** NEW **' : '', ' ', soy.$$escapeHtml(opt_data.description), (opt_data.abnormalResultsStr) ? ' (<span class="summaryAbnormalLab">' + soy.$$escapeHtml(opt_data.abnormalResultsStr) + '</span>)' : '', '</span>', (opt_data.cardSummary) ? '<span class="headerNote">' + soy.$$escapeHtml(opt_data.cardSummary) + '</span>' : '', (opt_data.isConfidential) ? '<span class="fr el8FeedItemConfidentialIcon"></span>' : '', (opt_data.fromLetterReceiptId && opt_data.reportType != 'consultation') ? '<span class="el8TagItem el8LabelTagItem fr">' + soy.$$escapeHtml(opt_data.fromLetterReceiptSender) + '</span>' : '', (el8Globals.FEATURES.BiDiLabs && opt_data.currentState == 'cancelled') ? '</span>' : '', '<div class="el8DialogItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div></div></div><div class="el8FeedItemSpacer" style="display:none;"></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.contentReport = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="cardDetails">');
  if (! el8Globals.FEATURES.ReportNotesAtBottom && ! opt_data.signDate) {
    output.append('<div class="reportNoteHolder"><div class="reportNotesContent">');
    el8.template.render.reportFeedItem.reportNoteSection(opt_data, output);
    output.append('</div></div>');
  }
  if (opt_data.signDate) {
    output.append('<div class="reportNoteHolder"><div class="reportNotesContent"><div class="reportNotesListContainer"><div class="reportDownloadWrap">', (opt_data.isConfidential) ? '<p class="el8AlignRight el8BrandColor">Confidential</p>' : '');
    if (opt_data.docTags) {
      output.append('<div class=\'doctags\'>');
      el8.template.appshared.docTags.content(soy.$$augmentData(opt_data, {docTags: opt_data.docTags, feedItemId: opt_data.feedItemId, align: 'right'}), output);
      output.append('</div>');
    }
    if (opt_data.hasActions) {
      if (opt_data.imageAsPdfUrl && opt_data.attachments.length == 0) {
        output.append('<p class="fl"><a target="_blank" rel="noopener" href="', soy.$$escapeHtml(opt_data.imageAsPdfUrl), '" tabindex="-1">View PDF version of report</a></p>');
      } else if (opt_data.printableLabReportUrl) {
        output.append('<p class="fl"><a target="_blank" rel="noopener" href="', soy.$$escapeHtml(opt_data.printableLabReportUrl), '" tabindex="-1">View PDF version of report</a></p>');
      } else if (opt_data.externalReportAttachments.length > 0) {
        var externalReportAttachmentList29525 = opt_data.externalReportAttachments;
        var externalReportAttachmentListLen29525 = externalReportAttachmentList29525.length;
        for (var externalReportAttachmentIndex29525 = 0; externalReportAttachmentIndex29525 < externalReportAttachmentListLen29525; externalReportAttachmentIndex29525++) {
          var externalReportAttachmentData29525 = externalReportAttachmentList29525[externalReportAttachmentIndex29525];
          output.append((externalReportAttachmentData29525.referenced_url) ? '<p class="fl"><a target="_blank" rel="noopener" href="' + soy.$$escapeHtml(externalReportAttachmentData29525.referenced_url) + '" tabindex="-1">External Report Detail</a></p>' : '');
        }
      }
    }
    output.append('<p class="el8SignoffText w65 ml35percent">');
    if (opt_data.formCollection) {
      el8.template.render.signOff.patientFormReviewSummaryText(opt_data, output);
    } else {
      el8.template.render.signOff.summaryText(opt_data, output);
    }
    output.append('</p></div><ol class="referring-threads">');
    el8.template.render.reportFeedItem.threads({threads: opt_data.referringThreads}, output);
    output.append('</ol>');
    if (opt_data.noteItems.length > 0) {
      output.append('<ol class="signed-report-note-list">');
      var itemList29545 = opt_data.noteItems;
      var itemListLen29545 = itemList29545.length;
      for (var itemIndex29545 = 0; itemIndex29545 < itemListLen29545; itemIndex29545++) {
        var itemData29545 = itemList29545[itemIndex29545];
        output.append('<li class="', (opt_data.hasActions) ? 'el8ItemHover ' : '', 'el8BulletText" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">', (opt_data.hasActions) ? '<div class="el8ItemButtonContainer"><button type="button" class="el8button ref-note-trigger el8ItemButton" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '" data-id="' + soy.$$escapeHtml(itemData29545.id) + '" tabindex="-1">Ref HPI</button></div>' : '');
        el8.template.ptdata.model.noteItem.summary(itemData29545, output);
        output.append('</li>');
      }
      output.append('</ol>');
    }
    output.append('<ul class="referring-addendums">');
    var addList29565 = opt_data.referringAddendums;
    var addListLen29565 = addList29565.length;
    for (var addIndex29565 = 0; addIndex29565 < addListLen29565; addIndex29565++) {
      var addData29565 = addList29565[addIndex29565];
      el8.template.ptdata.addendums.reportSummary({item: addData29565, hasActions: opt_data.hasActions}, output);
    }
    output.append('</ul></div>', (opt_data.currentUserIsPhysician && ! el8Globals.READ_ONLY) ? '<div class="report-notes-input el8FieldSection"><div class="reportAddendumInputWrap"><textarea type="text" class="fieldInputText w100" name="report-addendum" /></div><div class="reportAddendumInputButtonWrap"><button type="button" class="el8button submit-report-addendum el8PrimaryButton ebs-btn ebs-btn-primary">Save</button></div></div>' : '', '</div></div>');
  }
  el8.template.render.reportFeedItem.bodyContentReport(opt_data, output);
  if (opt_data.attachments.length > 0) {
    if (opt_data.attachments.length > 1 || ! (opt_data.fromLetterReceiptId || opt_data.originalDocumentSourceId) || opt_data.resultGrids.length != 0 || opt_data.images.length != 0) {
      output.append('<div class="el8ImagePlaceHolder el8ReportImageSize"><div class="el8ImagePlaceHolderText el8ReportImageMargin">');
      var itemList29581 = opt_data.attachments;
      var itemListLen29581 = itemList29581.length;
      for (var itemIndex29581 = 0; itemIndex29581 < itemListLen29581; itemIndex29581++) {
        var itemData29581 = itemList29581[itemIndex29581];
        output.append('<a class="el8ImageLinkText" target="_blank" rel="noopener" href="', soy.$$escapeHtml(itemData29581.downloadUrl), '" tabindex="-1">');
        el8.template.ptdata.model.attachment.summary(itemData29581, output);
        output.append('</a>');
      }
      output.append('</div></div>');
    }
  }
  if (opt_data.hasActions) {
    if (opt_data.fromLetterReceiptId) {
      output.append('<div class="reportNotesContent"><span class="el8StandardFontSize">Filed from <a class="item-details-trigger" data-id="', soy.$$escapeHtml(opt_data.fromLetterReceiptId), '" tabindex="-1">');
      el8.template.ptdata.letterReceipts.noteSummary(opt_data.fromLetterReceipt, output);
      output.append('</a></span></div>');
    }
  }
  if (el8Globals.FEATURES.ReportNotesAtBottom && ! opt_data.signDate) {
    output.append('<div class="reportNoteHolder"><div class="reportNotesBottomContent">');
    el8.template.render.reportFeedItem.reportNoteSection(opt_data, output);
    output.append('</div></div>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.reportNoteSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.printableLabReportUrl) ? '<div class="reportDownloadWrap"><p><a target="_blank" rel="noopener" href="' + soy.$$escapeHtml(opt_data.printableLabReportUrl) + '" tabindex="-1">View PDF version of report</a></p></div>' : '', '<ol class="referring-threads reportNote">');
  el8.template.render.reportFeedItem.threads({threads: opt_data.referringThreads}, output);
  output.append('</ol><div class="report-notes-input reportNewNotesWrap"><ol class="report-note-list"></ol><textarea type="text" class="w100" name="report-note"></textarea></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.bodyContentReport = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="cardDateDetails">', (! opt_data.signDate && opt_data.isConfidential) ? '<p class="el8AlignRight el8BrandColor el8StandardFontSize padr8">Confidential</p>' : '', (opt_data.messagePatientName) ? '<div class="el8Wrap"><span class="lgFont">' + soy.$$escapeHtml(opt_data.messagePatientName) + '</span>' + ((opt_data.messageDob) ? '<span class="leftIndent">(D.O.B.: ' + soy.$$escapeHtml(opt_data.messageDob) + ')</span>' : '') + '</div>' : '', '<div class="cardColumn fr w49">', (opt_data.documentDate) ? '<div class="fieldSection"><div class="reportInfoType fl">Document Date:</div><div class="reportInfoDate">' + (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : '') + '</div></div>' : '', (opt_data.createDate && opt_data.externalReportAttachments.length == 0) ? '<div class="fieldSection"><div class="reportInfoType fl">File Received:</div><div class="reportInfoDate">' + (soy.$$escapeHtml(opt_data.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.createDate)) : '') + '</div></div>' : '', (opt_data.orderStatus) ? '<div class="fieldSection"><div class="reportInfoType fl">Order Status:</div><div class="reportInfoDate">' + soy.$$escapeHtml(opt_data.orderStatus) + '</div></div>' : '', '</div>', (opt_data.resultGrids.length) ? '<div class="cardColumn w50">' + ((opt_data.requisitionNumber) ? '<div class="fieldSection"><div class="reportInfoType fl">Requisition No.:</div><div class="reportInfoDate">' + soy.$$escapeHtml(opt_data.requisitionNumber) + '</div></div>' : '') + '<div class="fieldSection"><div class="reportInfoType fl">Ordered by:</div><div class="reportInfoDate">' + ((opt_data.orderingProviderName) ? soy.$$escapeHtml(opt_data.orderingProviderName) : 'N/A') + '</div></div>' + ((opt_data.copiesTo) ? '<div class="fieldSection"><div class="reportInfoType fl">CC:</div><div class="reportInfoDate reportCopiedTo" title="' + soy.$$escapeHtml(opt_data.copiesTo) + '">' + soy.$$escapeHtml(opt_data.copiesTo) + '</div></div>' : '') + ((opt_data.vendorName) ? '<div class="fieldSection"><div class="reportInfoType fl">Vendor:</div><div class="reportInfoDate">' + soy.$$escapeHtml(opt_data.vendorName) + '</div></div>' : '') + ((opt_data.fastingFlag) ? '<div class="fieldSection"><div class="reportInfoType fl">Fasting: </div><div class="reportInfoDate">' + soy.$$escapeHtml(opt_data.fastingFlag) + '</div></div>' : '') + '</div>' : '', '</div>');
  if (opt_data.formCollection) {
    el8.template.render.reportFeedItem.reactMedicalFormFeedItem({feedItemId: opt_data.feedItemId}, output);
  }
  if (opt_data.resultGrids.length) {
    output.append('<div class="el8Wrap">', (! opt_data.isTxResultOnly) ? '<p class="key">Hover over lab value to see reference range and lab units.</p>' : '', '</div>');
    if (opt_data.resultGrids.length > 0) {
      var gridMapList29696 = opt_data.resultGrids;
      var gridMapListLen29696 = gridMapList29696.length;
      for (var gridMapIndex29696 = 0; gridMapIndex29696 < gridMapListLen29696; gridMapIndex29696++) {
        var gridMapData29696 = gridMapList29696[gridMapIndex29696];
        output.append('<ul class="results result-grid-container', (! gridMapData29696.signDate) ? ' needSignOff' : '', '">');
        el8.template.render.reportFeedItem.resultGrid.content(soy.$$augmentData(gridMapData29696, {feedItemId: opt_data.feedItemId, hasActions: opt_data.hasActions, lastManualEditUserName: opt_data.lastManualEditUserName, lastManualEditTime: opt_data.lastManualEditTime, isTxResultOnly: opt_data.isTxResultOnly}), output);
        output.append('</ul>');
      }
    }
    el8.template.render.reportFeedItem.imagesList(opt_data, output);
  } else if (opt_data.externalReportAttachments.length > 0) {
    el8.template.render.reportFeedItem.externalReport(opt_data, output);
  } else if (! opt_data.formCollection) {
    if (opt_data.images && opt_data.images.length > 0) {
      el8.template.render.reportFeedItem.imagesList(opt_data, output);
    } else {
      output.append((opt_data.attachments && opt_data.attachments.length == 1 && (opt_data.fromLetterReceiptId || opt_data.originalDocumentSourceId)) ? (opt_data.fromLetterReceiptId) ? '<div class="el8PDFPlaceholder"><span class="el8PDFPlaceholderIcon"><span class="el8PDFPlaceholderIconText">PDF</span></span><button class="el8button view-inline-pdf el8UploadButton el8ViewPDFButton" data-id="' + soy.$$escapeHtml(opt_data.attachments[0].printableId) + '"><span class="el8ViewIcon"></span>View PDF</button></div>' : '<div class="el8PDFPlaceholder"><a class="el8ImageLinkText" target="_blank" rel="noopener" href="' + soy.$$escapeHtml(opt_data.attachments[0].downloadUrl) + '" tabindex="-1">Download File</a></div>' : '<p class="el8QueueEmpty">There are no images associated with this report. If you recently uploaded a file, it may still be processing.</p>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.imagesList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.images && opt_data.images.length > 0) {
    if (opt_data.directlyRenderImages) {
      output.append('<ol>');
      var urlList29737 = opt_data.images;
      var urlListLen29737 = urlList29737.length;
      for (var urlIndex29737 = 0; urlIndex29737 < urlListLen29737; urlIndex29737++) {
        var urlData29737 = urlList29737[urlIndex29737];
        output.append('<li class="docImage el8CenterBlock"><img class="el8MaxWidth100" src="', soy.$$escapeHtml(urlData29737), '" /></li>');
      }
      output.append('</ol>');
    } else {
      output.append('<div class="report-images"></div>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.contentReferralOrder = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer cardDetails"><h2 class="el8OrderTitle">Referral</h2>');
  el8.template.render.reportFeedItem.forPatient({patient: opt_data.patient}, output);
  output.append('<div class="orderDetailsContainer"><div class="el8FieldSection"><label class="el8label el8FieldMedium">Consultant:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize">', soy.$$escapeHtml(opt_data.consultantName), '<span>', (opt_data.specialtyName) ? ' (' + soy.$$escapeHtml(opt_data.specialtyName) + ')</span>' : '', '</div></div>');
  el8.template.render.reportFeedItem.referralDetail.contentReferralOrderReason(opt_data, output);
  el8.template.render.reportFeedItem.referralDetail.contentReferralOrderDetail(opt_data, output);
  if (el8Globals.FEATURES.BiDiLabs) {
    el8.template.ptdata.model.order.reminderStatus({order: opt_data.order, reportFeed: true}, output);
  }
  if (opt_data.attachments) {
    output.append('<div class="el8SectionDivider mt5"><ol class="padv5 el8StandardList el8AttachmentList">');
    el8.template.render.reportFeedItem.attachmentSection({attachments: opt_data.attachments}, output);
    output.append('</ol></div>');
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.forPatient = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p><span class="emphasis">For: ');
  el8.template.ptdata.patients.fullName(opt_data.patient, output);
  output.append('</span> (D.O.B.: ', (soy.$$escapeHtml(opt_data.patient.dob)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.patient.dob)) : ''), ') Patient ID:&nbsp;', soy.$$escapeHtml(opt_data.patient.id), '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.attachmentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var aList29782 = opt_data.attachments;
  var aListLen29782 = aList29782.length;
  for (var aIndex29782 = 0; aIndex29782 < aListLen29782; aIndex29782++) {
    var aData29782 = aList29782[aIndex29782];
    output.append('<li class="attachment-detail" data-id="', soy.$$escapeHtml(aData29782.id), '"><img class="fl el8PaperClip" src="/static/images/transparent_16x16.png" alt="Attachment Icon" />');
    el8.template.ptdata.letters.attachments.savedAttachmentSummary(soy.$$augmentData(aData29782, {noAttachmentLinks: false}), output);
    output.append('<div class="el8IconOpenArrow el8IconOpenArrowPositionAttachment"></div></li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.contentLabOrder = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer cardDetails"><h2 class="el8OrderTitle">Lab Order', (opt_data.vendorName) ? ': ' + soy.$$escapeHtml(opt_data.vendorName) : '', '</h2><div class="el8FieldSectionOverflow">', (opt_data.displayStatMethod || opt_data.testCenterName) ? '<div class="w40 fr">' + ((opt_data.displayStatMethod) ? '<p class="emphasis">' + soy.$$escapeHtml(opt_data.displayStatMethod) + '</p>' : '') + ((opt_data.testCenterName) ? '<p>' + soy.$$escapeHtml(opt_data.testCenterName) + '</p>' : '') + '</div>' : '', (opt_data.order.submissionState == 'failed') ? '<p class="el8FeedItemAbnormalText" style="padding: 6px">The electronic order submission failed. Please use the \'Actions\' menu to reorder this test. If this is an emergency, call the servicing lab directly.</p>' : '', '<div class="w55">');
  el8.template.render.reportFeedItem.forPatient({patient: opt_data.patient}, output);
  output.append('</div></div><div class="orderDetailsContainer">', (opt_data.order) ? '<div class="emphasis" style="font-size: 1.2em;">Requisition Number: ' + soy.$$escapeHtml(opt_data.order.requisitionId) + '</div>' : '', (opt_data.standingOrderFrequency) ? '<p class="emphasis spacer5">STANDING ORDER</p>' : '', '<p class="el8Wrap">', soy.$$escapeHtml(opt_data.displayFastingMethod), '</p><div class="fieldNoteSection"><label class="el8label el8FieldMedium">Tests:</label><ol class="el8FieldMediumLabelPadding">');
  var testNameList29829 = opt_data.testNames;
  var testNameListLen29829 = testNameList29829.length;
  for (var testNameIndex29829 = 0; testNameIndex29829 < testNameListLen29829; testNameIndex29829++) {
    var testNameData29829 = testNameList29829[testNameIndex29829];
    output.append('<li class="el8BulletText"><span class="emphasis">', soy.$$escapeHtml(testNameData29829), '</span><br/>', (opt_data.standingOrderFrequency) ? 'Freq: ' + soy.$$escapeHtml(opt_data.standingOrderFrequency) + '<br/>' : '', (opt_data.standingOrderEndDate) ? 'End Date: ' + (soy.$$escapeHtml(opt_data.standingOrderEndDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.standingOrderEndDate)) : '') : '', '</li>');
  }
  output.append('</ol></div>');
  if (opt_data.icd10Codes && opt_data.icd10Codes.length) {
    output.append('<div class="fieldNoteSection"><label class="el8label el8FieldMedium">ICD-10:</label><ol class="el8FieldMediumLabelPadding">');
    el8.template.render.reportFeedItem.icd10s(opt_data, output);
    output.append('</ol></div>');
  }
  if (opt_data.icd9Codes && opt_data.icd9Codes.length) {
    output.append('<div class="fieldNoteSection"><label class="el8label el8FieldMedium">ICD-9:</label><ol class="el8FieldMediumLabelPadding">');
    el8.template.render.reportFeedItem.icd9s(opt_data, output);
    output.append('</ol></div>');
  }
  if (opt_data.ccNames.length) {
    output.append('<div class="el8FieldSection"><label class="el8label el8FieldMedium">Copy To:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize">');
    var ccNameList29859 = opt_data.ccNames;
    var ccNameListLen29859 = ccNameList29859.length;
    for (var ccNameIndex29859 = 0; ccNameIndex29859 < ccNameListLen29859; ccNameIndex29859++) {
      var ccNameData29859 = ccNameList29859[ccNameIndex29859];
      output.append(soy.$$escapeHtml(ccNameData29859), (ccNameIndex29859 == ccNameListLen29859 - 1) ? '.' : '; ');
    }
    output.append('</div></div>');
  }
  output.append((opt_data.testCenterNotes) ? '<p class="el8Wrap">Notes/Instructions to Lab: ' + soy.$$escapeHtml(opt_data.testCenterNotes) + '</p>' : '', (opt_data.patientInstructions) ? '<p class="el8Wrap">Note to Patient: ' + soy.$$escapeHtml(opt_data.patientInstructions) + '</p>' : '', (opt_data.followUpMethod) ? '<p class="el8Wrap">Follow Up: ' + soy.$$escapeHtml(opt_data.followUpMethod) + '</p>' : '', (opt_data.collectionDatetime) ? '<p class="el8Wrap">Collection: ' + (soy.$$escapeHtml(opt_data.collectionDatetime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.collectionDatetime)) : '') + ', ' + (soy.$$escapeHtml(opt_data.collectionDatetime)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.collectionDatetime)) : '') + '</p>' : (opt_data.dateForTest) ? '<p class="el8Wrap">Dr. Wants Test Done On: ' + (soy.$$escapeHtml(opt_data.dateForTest)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.dateForTest)) : '') + '</p>' : (opt_data.canDocumentCollection) ? '<p class="el8Wrap">Collection:<span class="ml5 el8FeedItemLightText">Date and time not documented.</span><a class="ml5 document-collection-trigger" data-id="' + soy.$$escapeHtml(opt_data.order.id) + '">Document collection</a></p>' : '', '</div>');
  if (el8Globals.FEATURES.BiDiLabs) {
    el8.template.ptdata.model.order.reminderStatus({order: opt_data.order, reportFeed: true}, output);
  }
  if (opt_data.signDate) {
    output.append('<p class="el8SignoffText el8AlignRight">');
    el8.template.render.signOff.summaryText(opt_data, output);
    output.append('</p>');
  }
  output.append((opt_data.order.submissionTime) ? '<p class="el8SignoffText el8AlignRight">eOrder sent to Lab on ' + (soy.$$escapeHtml(opt_data.order.submissionTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.order.submissionTime)) : '') + '</p>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.contentAncillaryOrder = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer cardDetails"><!-- Sleep to Generic order UI reskin --><h2 class="el8OrderTitle">', (! opt_data.orderType == 'sleep' || ! el8Globals.FEATURES.GenericOrder) ? (soy.$$escapeHtml(opt_data.orderType)? soy.$$escapeHtml(opt_data.orderType).capitalize() : '') + ' ' : '', ' Order</h2><div class="el8FieldSectionOverflow">', (opt_data.testCenterName || opt_data.displayStatMethod) ? '<div class="w40 fr">' + ((opt_data.displayStatMethod) ? '<p class="emphasis">' + soy.$$escapeHtml(opt_data.displayStatMethod) + '</p>' : '') + ((opt_data.testCenterName) ? '<p>' + soy.$$escapeHtml(opt_data.testCenterName) + '</p>' : '') + '</div>' : '', '<div class="w55">');
  el8.template.render.reportFeedItem.forPatient({patient: opt_data.patient}, output);
  output.append('</div></div><div class="orderDetailsContainer"><div class="fieldNoteSection"><label class="el8label el8FieldMedium">Tests:</label><ol class="el8FieldMediumLabelPadding">');
  var testNameList29945 = opt_data.testNames;
  var testNameListLen29945 = testNameList29945.length;
  for (var testNameIndex29945 = 0; testNameIndex29945 < testNameListLen29945; testNameIndex29945++) {
    var testNameData29945 = testNameList29945[testNameIndex29945];
    output.append('<li class="el8BulletText"><span class="emphasis">', soy.$$escapeHtml(testNameData29945), '</span></li>');
  }
  output.append('</ol></div><div class="el8FieldSection"><label class="el8label el8FieldMedium">Reason:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize emphasis">', soy.$$escapeHtml(opt_data.clinicalReason), '</div></div>');
  if (opt_data.icd10Codes && opt_data.icd10Codes.length) {
    output.append('<div class="fieldNoteSection"><label class="el8label el8FieldMedium">ICD-10:</label><ol class="el8FieldMediumLabelPadding">');
    el8.template.render.reportFeedItem.icd10s(opt_data, output);
    output.append('</ol></div>');
  }
  if (opt_data.icd9Codes && opt_data.icd9Codes.length) {
    output.append('<div class="fieldNoteSection"><label class="el8label el8FieldMedium">ICD-9:</label><ol class="el8FieldMediumLabelPadding">');
    el8.template.render.reportFeedItem.icd9s(opt_data, output);
    output.append('</ol></div>');
  }
  if (opt_data.ccNames.length) {
    output.append('<div class="el8FieldSection"><label class="el8label el8FieldMedium">Copy To:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize">');
    var ccNameList29966 = opt_data.ccNames;
    var ccNameListLen29966 = ccNameList29966.length;
    for (var ccNameIndex29966 = 0; ccNameIndex29966 < ccNameListLen29966; ccNameIndex29966++) {
      var ccNameData29966 = ccNameList29966[ccNameIndex29966];
      output.append(soy.$$escapeHtml(ccNameData29966), ' ');
    }
    output.append('</div></div>');
  }
  output.append((opt_data.testCenterNotes) ? '<p class="el8Wrap">Notes/Instructions to Center: ' + soy.$$escapeHtml(opt_data.testCenterNotes) + '</p>' : '', (opt_data.patientInstructions) ? '<p class="el8Wrap">Note to Patient: ' + soy.$$escapeHtml(opt_data.patientInstructions) + '</p>' : '', (opt_data.followUpMethod) ? '<p class="el8Wrap">Follow Up: ' + soy.$$escapeHtml(opt_data.followUpMethod) + '</p>' : '', (opt_data.dateForTest) ? '<p class="el8Wrap">Dr. Wants Tests Done Around: ' + (soy.$$escapeHtml(opt_data.dateForTest)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.dateForTest)) : '') + '</p>' : '', '</div>');
  if (opt_data.signDate) {
    output.append('<p class="el8SignoffText el8AlignRight">');
    el8.template.render.signOff.summaryText(opt_data, output);
    output.append('</p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.imageFeed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol id="', soy.$$escapeHtml(opt_data.listId), '"></ol><div class="el8PageFeedContainer"><button type="button" id="report-', soy.$$escapeHtml(opt_data.reportId), '-images-more-btn" class="el8button el8SectionButton" tabindex="-1">More</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.image = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="docImage el8CenterBlock image-item-wrap"><div data-src="', soy.$$escapeHtml(opt_data.url), '" class="image-item imageLoading" data-id="', soy.$$escapeHtml(opt_data.reportId), '"></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.threads = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.threads) {
    var threadList30014 = opt_data.threads;
    var threadListLen30014 = threadList30014.length;
    for (var threadIndex30014 = 0; threadIndex30014 < threadListLen30014; threadIndex30014++) {
      var threadData30014 = threadList30014[threadIndex30014];
      el8.template.render.reportFeedItem.thread({thread: threadData30014}, output);
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.thread = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8BulletText">');
  el8.template.ptdata.model.message.referencedReportSummary(opt_data.thread, output);
  output.append('</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.icd10s = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var codeList30023 = opt_data.icd10Codes;
  var codeListLen30023 = codeList30023.length;
  for (var codeIndex30023 = 0; codeIndex30023 < codeListLen30023; codeIndex30023++) {
    var codeData30023 = codeList30023[codeIndex30023];
    output.append('<li id="select_w3" class="el8BulletText"><span class="emphasis">', soy.$$escapeHtml(codeData30023), '</span>', (opt_data.icd10Descs[codeIndex30023]) ? ' - ' + soy.$$escapeHtml(opt_data.icd10Descs[codeIndex30023]) : '', '</li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.icd9s = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var codeList30034 = opt_data.icd9Codes;
  var codeListLen30034 = codeList30034.length;
  for (var codeIndex30034 = 0; codeIndex30034 < codeListLen30034; codeIndex30034++) {
    var codeData30034 = codeList30034[codeIndex30034];
    output.append('<li id="select_w3" class="el8BulletText"><span class="emphasis">', soy.$$escapeHtml(codeData30034), '</span>', (opt_data.icd9Descs[codeIndex30034]) ? ' - ' + soy.$$escapeHtml(opt_data.icd9Descs[codeIndex30034]) : '', '</li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.contentImportedVisit = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="cardDetails pad10">');
  if (opt_data.docTags && opt_data.docTags.length) {
    output.append('<div class="reportDownloadWrap"><div class=\'doctags\'>');
    el8.template.appshared.docTags.content(soy.$$augmentData(opt_data, {docTags: opt_data.docTags, feedItemId: opt_data.feedItemId, align: 'right'}), output);
    output.append('</div></div>');
  }
  el8.template.render.chartFeedItemNew.visitNoteCore(opt_data, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.contentImportedNonvisit = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="cardDetails pad10">');
  if (opt_data.docTags && opt_data.docTags.length) {
    output.append('<div class="reportDownloadWrap"><div class=\'doctags\'>');
    el8.template.appshared.docTags.content(soy.$$augmentData(opt_data, {docTags: opt_data.docTags, feedItemId: opt_data.feedItemId, align: 'right'}), output);
    output.append('</div></div>');
  }
  el8.template.render.chartFeedItemNew.nonvisitNoteCore(opt_data, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.externalReport = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="el8Wrap"></div><ul class="results result-grid-container">');
  var externalReportList30070 = opt_data.externalReportAttachments;
  var externalReportListLen30070 = externalReportList30070.length;
  for (var externalReportIndex30070 = 0; externalReportIndex30070 < externalReportListLen30070; externalReportIndex30070++) {
    var externalReportData30070 = externalReportList30070[externalReportIndex30070];
    output.append('<li class="itemInstr result-value-note el8OverflowXScroll"><div class="labResultValueNote"><pre class="el8Preserve">', soy.$$escapeHtml(externalReportData30070.summary), '</pre></div></li>');
  }
  output.append('</ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.reactMedicalFormFeedItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="react-medical-form-feed-item-', soy.$$escapeHtml(opt_data.feedItemId), '"></div>');
  if (!opt_sb) return output.toString();
};
